import React, { Component } from "react"
import { Mutation } from "react-apollo"
import REQUEST_HELP from "../../graphql/requestHelp.graphql"
import Button from "../Button"
import validator from "validator"
import Message from "../Message"
import Modal from "../Modal"
import MessageModal from "../MessageModal"

import "./helpForm.scss"

class HelpForm extends Component {
  state = {
    errors: {},
    dropdown: "Customer Service",
    email: "",
    name: "",
    phone: "",
    companyName: "",
    jobTitle: "",
    companyAddress: "",
    message: "",
    modalIsOpen: false,
    modal: {
      title: "",
      message: "",
      callToAction: {
        route: "",
        buttonText: "",
      },
    },
  }

  handleChange = (key, e) => {
    this.setState({
      [key]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    let {
      errors,
      email,
      phone,
      name,
      companyName,
      jobTitle,
      companyAddress,
      message,
      dropdown,
    } = this.state

    const requiredFields = ["name", "email", "message"]

    errors = requiredFields.reduce((acc, k) => {
      if (!this.state[k]) {
        return { ...acc, [k]: "Required" }
      }
      return acc
    }, {})

    if (email && !validator.isEmail(email)) {
      errors.email = "Invalid email"
    }

    if (phone && !validator.isMobilePhone(phone, "any")) {
      errors.phone = "Invalid phone number"
    }

    const hasErrors = Object.keys(errors).length > 0

    if (hasErrors) {
      this.setState({ errors })
      return
    } else {
      this.props
        .requestHelp({
          variables: {
            name,
            email,
            message,
            phone,
            companyName,
            jobTitle,
            companyAddress,
            reason: dropdown,
          },
        })
        .then(({ data }) => {
          let { payload, message } = data.requestHelp
          if (payload !== "success") {
            this.setState({
              modalIsOpen: true,
              modal: {
                title: "We're Sorry",
                message: "An error occured while processing your request.",
                type: "error",
                callToAction: {
                  buttonText: "Close",
                },
              },
            })
            return
          }

          this.setState({
            modalIsOpen: true,
            modal: {
              title: "Thank You!",
              message:
                "An email has been sent. We will respond in a timely manner.",
              type: "success",
              callToAction: {
                route: "",
                buttonText: "Return Home",
              },
            },
          })
        })
    }
  }

  handlePhone = (e) => {
    let value = e.target.value

    e.target.value = value.replace(/[^\d\+]/g, "")

    this.handleChange("phone", e)
  }

  handleCloseModal = () => {
    this.setState({
      modalIsOpen: false,
    })
  }

  render() {
    let { modalIsOpen, modal } = this.state
    return (
      <div className="help-form-container">
        <div id="help-dropdown" className="help-input-small">
          <label>What are you here for?</label>
          <select
            id="help-dropdown-input"
            value={this.state.dropdown}
            onChange={(e) => this.handleChange("dropdown", e)}
          >
            <option value="Customer Service">Customer Service</option>
            <option value="Sales">Sales</option>
            <option value="Analyst Relations">Analyst Relations</option>
            <option value="Consulting">Consulting</option>
            <option value="Purchasing Reports">Purchasing Reports</option>
            <option value="Subscribing">Subscribing</option>
            <option value="ACH / Soft Dollar">ACH / Soft Dollar</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div id="help-email" className="help-input-small">
          <label>Email</label>
          <input
            type="text"
            value={this.state.email}
            onChange={(e) => this.handleChange("email", e)}
          />
          <span className="input-error">{this.state.errors.email}</span>
        </div>

        <div id="help-full-name" className="help-input-small">
          <label>Full Name</label>
          <input
            type="text"
            value={this.state.name}
            onChange={(e) => this.handleChange("name", e)}
          />
          <span className="input-error">{this.state.errors.name}</span>
        </div>

        <div id="help-phone" className="help-input-small">
          <label>Phone</label>
          <input
            type="text"
            value={this.state.phone}
            onChange={this.handlePhone}
          />
          <span className="input-error">{this.state.errors.phone}</span>
        </div>

        <div id="help-company-name" className="help-input-small">
          <label>Company Name</label>
          <input
            type="text"
            value={this.state.companyName}
            onChange={(e) => this.handleChange("companyName", e)}
          />
        </div>

        <div id="help-job-title" className="help-input-small">
          <label>Job Title</label>
          <input
            type="text"
            value={this.state.jobTitle}
            onChange={(e) => this.handleChange("jobTitle", e)}
          />
        </div>

        <div id="help-company-address" className="help-input-large">
          <label>Company Address</label>
          <input
            type="text"
            value={this.state.companyAddress}
            onChange={(e) => this.handleChange("companyAddress", e)}
          />
        </div>

        <div id="help-message" className="help-input-large">
          <label>Message</label>
          <textarea
            id="help-message-input"
            value={this.state.message}
            onChange={(e) => this.handleChange("message", e)}
          />
          <span className="input-error">{this.state.errors.message}</span>
        </div>

        <div id="help-submit-button-container">
          <div id="help-submit-button">
            <Button
              text={"SUBMIT"}
              action={this.handleSubmit}
              classes={["small-caps", "btn-primary"]}
              fullWidth={true}
            />
          </div>
        </div>

        <MessageModal
          isOpen={modalIsOpen}
          close={this.handleCloseModal}
          title={modal.title}
          message={modal.message}
          type={modal.type}
          callToAction={{
            route: modal.callToAction.route,
            buttonText: modal.callToAction.buttonText,
          }}
        ></MessageModal>
      </div>
    )
  }
}

const HelpFormWithMutation = (componentProps) => (
  <Mutation mutation={REQUEST_HELP}>
    {(mutation) => <HelpForm {...componentProps} requestHelp={mutation} />}
  </Mutation>
)

export default HelpFormWithMutation
